module.exports = __webpack_public_path__ + "img/3.e3a58939.png";